import angular from 'angular'
import * as logger from '../../../../src/components/toaster'

/**
 * @deprecated
 */
type LegacyLoggerConstant = Record<'SUCCESS', 'success'>
export const legacyLoggerConstant: LegacyLoggerConstant = {
  SUCCESS: 'success'
}

/**
 * @deprecated
 */
export function handleResolve(propertiesStr: any, options?: any) {
  if (typeof propertiesStr !== 'string') {
    propertiesStr = ''
  }
  if (!options) {
    options = {}
  }
  return (
    response: Partial<
      angular.IHttpPromiseCallbackArg<LegacyTeamServerApiResponse>
    >
  ) => {
    const properties = propertiesStr.split('.')
    let last = response
    if (!properties) {
      return last
    }
    properties.forEach((property) => {
      last = last[property]
    })
    if (
      typeof options.log === 'string' &&
      options.log === legacyLoggerConstant.SUCCESS
    ) {
      if (response.data) {
        response.data.messages.forEach((message) => logger.logSuccess(message))
      }
    }
    return last
  }
}

/**
 * @deprecated
 */
export function logSuccess(
  response: Partial<
    angular.IHttpPromiseCallbackArg<LegacyTeamServerApiResponse>
  >
) {
  if (response.data) {
    logger.logSuccess(response.data.messages[0])
  }
}

/**
 * @deprecated
 */
export function logClear() {
  logger.logClear()
}

/**
 * @deprecated
 */
export function buildParamsString(obj: object) {
  let str = '?'
  Object.keys(obj).forEach((key, i) => {
    if (i > 0) {
      str += '&'
    }
    str += key + '=' + obj[key]
  })
  return str
}

/**
 * @deprecated
 */
export interface LegacyServiceUtils {
  readonly handleError: (response: any, options?: any) => angular.IPromise<any>
  readonly handleResolve: (
    propertiesStr?: any,
    options?: any
  ) => (
    response: Partial<
      angular.IHttpPromiseCallbackArg<LegacyTeamServerApiResponse>
    >
  ) => any
  readonly buildParamsString: (obj: any) => string
  readonly logSuccess: (
    response: Partial<
      angular.IHttpPromiseCallbackArg<LegacyTeamServerApiResponse>
    >
  ) => void
  readonly logClear: () => void
  readonly LOGGER: LegacyLoggerConstant
}

/**
 * @deprecated This only exists to provide some type declarations and basic tests.
 */
export function ServiceUtils(
  $q: {
    readonly reject: angular.IQService['reject']
  },
  ErrorService: LegacyErrorService
): LegacyServiceUtils {
  'ngInject'

  return {
    handleError,
    handleResolve,
    buildParamsString,
    logSuccess,
    logClear,
    LOGGER: legacyLoggerConstant
  }

  function handleError(response: any, options?: object) {
    ErrorService.processError(response, options)
    return $q.reject(response)
  }
}
